const fitGuideControllers = new WeakMap();

const initializeFitGuide = (guide) => {
  const existingController = fitGuideControllers.get(guide);
  if (existingController) return existingController;

  const inputs = Array.from(guide.querySelectorAll('[data-fit-input]'));
  const resultRegion = guide.querySelector('[data-fit-result-region]');

  if (!inputs.length || !resultRegion) return null;

  const getScrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';

  const handleInputChange = (input) => {
    if (!input.checked || window.Shopify?.designMode) return;

    const resultPanel = resultRegion.querySelector(
      `[data-fit-result-panel][data-fit-result="${CSS.escape(input.dataset.fitKey || '')}"]`,
    );

    if (!(resultPanel instanceof HTMLElement)) return;

    window.requestAnimationFrame(() => {
      resultPanel.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
    });
  };

  inputs.forEach((input) => input.addEventListener('change', () => handleInputChange(input)));

  const controller = {
    getInputByBlockId: (blockId) => inputs.find((input) => input.dataset.fitBlockId === blockId) || null,
    selectInput: (input) => {
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },
  };

  fitGuideControllers.set(guide, controller);
  return controller;
};

const initializeOtkFindYourFit = (scope = document) => {
  const guides = [];

  if (scope instanceof Element && scope.matches('[data-otk-fit-guide]')) guides.push(scope);
  if (scope.querySelectorAll) guides.push(...scope.querySelectorAll('[data-otk-fit-guide]'));

  guides.forEach(initializeFitGuide);
};

const getGuideFromEditorEvent = (event) => {
  if (event.target instanceof Element) {
    const guide = event.target.closest('[data-otk-fit-guide]');
    if (guide) return guide;
  }

  const sectionId = event.detail?.sectionId;
  if (!sectionId) return null;

  return document.querySelector(`[data-fit-section-id="${CSS.escape(sectionId)}"]`);
};

const bindOtkFindYourFitEvents = () => {
  if (window.__otkFindYourFitEventsBound) return;
  window.__otkFindYourFitEventsBound = true;

  document.addEventListener('shopify:section:load', (event) => initializeOtkFindYourFit(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const guide = getGuideFromEditorEvent(event);
    const blockId = event.detail?.blockId;
    if (!guide || !blockId) return;

    const controller = initializeFitGuide(guide);
    const input = controller?.getInputByBlockId(blockId);
    if (input) controller.selectInput(input);
  });
};

bindOtkFindYourFitEvents();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeOtkFindYourFit(), { once: true });
} else {
  initializeOtkFindYourFit();
}
